import { View, Text } from 'react-native'
import * as React from 'react'
import { DataTable } from 'react-native-paper'

export const permissionsHeaders = [
  { label: 'Create', key: 'create' },
  { label: 'Update', key: 'update' },
  { label: 'View', key: 'view' },
  { label: 'Delete', key: 'delete' },
  { label: 'Reassign', key: 'reassign' },
  { label: 'Lock Children', key: 'lock_children', isTriState: false }
]
const columnHeight = 120
export const columnWidth = 40
export const rowHeaderWidth = 180
export const PermissionsRowHeaders = () => {
  return (
    <View>
      <DataTable.Header fixedHeader={true} style={{ height: columnHeight }}>
        <DataTable.Title
          style={{ flex: 1, marginRight: 30, minWidth: rowHeaderWidth }}
        >
          Module/Entity Type
        </DataTable.Title>
        {permissionsHeaders.map((r) => {
          return (
            <DataTable.Title
              style={{
                height: columnHeight,
                maxWidth: columnWidth,
                width: columnWidth,
                position: 'relative',
                borderRightWidth: StyleSheet.hairlineWidth
              }}
              key={r.key}
            >
              <View
                style={{
                  transform: 'rotate(90deg)',
                  marginTop: columnHeight / 2 - 30,
                  marginLeft: -columnWidth - columnWidth / 2,
                  width: columnHeight,
                  height: columnWidth,
                  position: 'absolute'
                }}
              >
                <Text>{r.label}</Text>
              </View>
            </DataTable.Title>
          )
        })}
        <DataTable.Title style={{ flex: 10 }}></DataTable.Title>
      </DataTable.Header>
    </View>
  )
}
